import type { Action } from 'react-sweet-state';
import type { State } from './types';

export const setDeferredNavigationLink =
	(deferredNavigationLink: string): Action<State> =>
	({ setState }) =>
		setState({ deferredNavigationLink });

export const actions = { setDeferredNavigationLink } as const;
